// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"bab80c45","209":"fae077fb","289":"877fbbb8","464":"577e4617","526":"a816d909","645":"376d2e26","832":"5ea0fc83","976":"046d2f40"}[chunkId] + ".chunk.js";
};